import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const DEFAULT_TITLE = 'Sitecore Cloud Portal';
const prefixTitles: [string, string][] = [
  ['/', DEFAULT_TITLE],
  ['/profile', `Manage account - ${DEFAULT_TITLE}`],
  ['/subscriptions', `Subscriptions - ${DEFAULT_TITLE}`],
  ['/admin/members/page', `Users - ${DEFAULT_TITLE}`],
  ['/admin/members/configuration', `Users configuration - ${DEFAULT_TITLE}`],
  ['/admin/user-groups', `User groups - ${DEFAULT_TITLE}`],
  ['/admin/invites/page', `Invitations - ${DEFAULT_TITLE}`],
  ['/admin/usage', `Usage - ${DEFAULT_TITLE}`],
  ['/admin/multifactor-authentication', `Multi-factor authentication - ${DEFAULT_TITLE}`],
  ['/admin/sso', `Single sign-on - ${DEFAULT_TITLE}`],
  ['/admin/support-access', `Sitecore Support access - ${DEFAULT_TITLE}`],
  ['/admin/custom-hostnames', `Custom hostnames - ${DEFAULT_TITLE}`],
  ['/admin/audit-logs', `Audit logs - ${DEFAULT_TITLE}`],
  ['/admin/context-ids', `Context IDs - ${DEFAULT_TITLE}`],
];

const getTitleForPathname = (pathname: string): string => {
  const match = prefixTitles.find(([prefix]) => {
    if (prefix === '/') {
      return pathname === prefix;
    }
    return pathname === prefix || pathname.startsWith(`${prefix}/`);
  });
  return match ? match[1] : DEFAULT_TITLE;
};

export const useSetDocumentTitle = () => {
  const location = useLocation();

  useEffect(() => {
    document.title = getTitleForPathname(location.pathname);
  }, [location.pathname]);
};
